import React from 'react';
import {
  BellIcon,
  ClockIcon,
  FileTextIcon,
  HeartIcon,
  PaperplaneIcon,
  TasklistIcon,
} from '@navikt/aksel-icons';
import type { AutomationStats } from '../../../../api/queries';
import classes from './AutomationStatsCard.module.css';

export interface AutomationStatsCardProps {
  stats: AutomationStats;
  translations: {
    title: string;
    description: string;
    remindersSent: string;
    deadlineExtensions: string;
    resultsShared: string;
    actionPlanInvitations: string;
    actionPlanNotifications: string;
    aiRecommendationsGenerated: string;
  };
}

/**
 * Card displaying automation statistics
 */
export const AutomationStatsCard: React.FC<AutomationStatsCardProps> = ({
  stats,
  translations,
}) => {
  const automationItems = [
    {
      label: translations.remindersSent,
      value: stats.remindersSent,
      Icon: BellIcon,
    },
    {
      label: translations.deadlineExtensions,
      value: stats.deadlineExtensions,
      Icon: ClockIcon,
    },
    {
      label: translations.resultsShared,
      value: stats.resultsShared,
      Icon: PaperplaneIcon,
    },
    {
      label: translations.actionPlanInvitations,
      value: stats.actionPlanInvitations,
      Icon: TasklistIcon,
    },
    {
      label: translations.actionPlanNotifications,
      value: stats.actionPlanNotifications,
      Icon: FileTextIcon,
    },
    {
      label: translations.aiRecommendationsGenerated,
      value: stats.aiRecommendationsGenerated,
      Icon: HeartIcon,
    },
  ];

  return (
    <section aria-labelledby="automation-heading" className={classes.container}>
      <div className={classes.intro}>
        <h2 id="automation-heading" className={classes.title}>
          {translations.title}
        </h2>
        <p className={classes.description}>{translations.description}</p>
      </div>
      <ul className={classes.grid}>
        {automationItems.map((item) => (
          <li key={item.label} className={classes.statItem}>
            <item.Icon className={classes.icon} aria-hidden />
            <span className={classes.statContent}>
              <span className={classes.statValue}>{item.value}</span>
              <span className={classes.statLabel}>{item.label}</span>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};
